<template>
  <CCardBody>
    <CDataTable border :items="items" :fields="fields">
      <td slot="id" slot-scope="{ item }">
        <span v-if="item.provider_id">
          <ProviderHoverComponent :id="item.provider_id" />
        </span>
      </td>

      <td slot="amount" slot-scope="{ item }">
        {{ item.total_payout | currency100 }}
      </td>
    </CDataTable>
  </CCardBody>
</template>

<script>
import { Common } from '@/constants';
import ProviderHoverComponent from '@/components/ProviderHoverComponent.vue';

export default {
  components: { ProviderHoverComponent },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },

  data: function () {
    return {
      datetimeFormat: Common.datetimeFormat,
      dateFormat: Common.dateFormat,
      fields: [
        {
          key: 'id',
          label: 'SP',
        },
        {
          key: 'business_name',
          label: 'BusinessName',
        },
        {
          key: 'registered_id',
          label: 'RegisteredID',
        },
        {
          key: 'phone_number',
          label: 'PhoneNumber',
        },
        {
          key: 'amount',
          label: 'Amount',
        },
      ],
    };
  },
  methods: {},
};
</script>
